module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/47/assets/images/46c10ebf6bbefad5f5b7819780df0ba3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_locked_color.svg
// module id = TgKa
// module chunks = 0